import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import { IPlanService } from "@shared/interfaces/plan-service.interface";
import { PlanListPaginatedDto } from "@shared/types/plans/plan-list-paginated.dto";
import { PlanDto, UpdatePlanDto } from "@shared/types/plans/plan.dto";
import { UserProviderType } from "@shared/types/user/enum/user-provider-type.enum";

@appInjectable()
export class PlanService extends BaseService implements IPlanService {
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  async create(dto: PlanDto): Promise<PlanDto> {
    const { data } = await this.httpClient.post<PlanDto>(
      "/plans",
      {
        ...dto,
      },
      {
        baseURL: this.baseURL,
      },
    );

    return data;
  }

  async update(dto: UpdatePlanDto): Promise<PlanDto> {
    const { data } = await this.httpClient.patch<PlanDto>(
      `/plans/${dto.id}`,
      {
        ...dto,
      },
      {
        baseURL: this.baseURL,
      },
    );

    return data;
  }

  async list(dto: {
    page?: number;
    pageSize?: number;
    disabled?: string;
    provider?: UserProviderType;
  }): Promise<PlanListPaginatedDto> {
    const { data } = await this.httpClient.get<PlanListPaginatedDto>("/plans", {
      params: dto,
      baseURL: this.baseURL,
    });

    return data;
  }

  async delete(dto: PlanDto): Promise<PlanDto> {
    const { data } = await this.httpClient.delete<PlanDto>(`/plans/${dto.id}`, {
      baseURL: this.baseURL,
    });
    return data;
  }

  async syncWithRevenueCat(): Promise<void> {
    await this.httpClient.post(
      "/plans/sync-with-revenuecat",
      {},
      {
        baseURL: this.baseURL,
      },
    );
  }
}
